export class Blockchain {
  idBlockchain: number;
  name: string;
  preg: string;
  tag: boolean;
  decimalPlace: number;
  locked: boolean;

  constructor(
    idBlockchain: number,
    name: string,
    preg: string,
    tag: boolean,
    decimalPlace: number,
    locked: boolean,
  ) {
    this.idBlockchain = idBlockchain;
    this.name = name;
    this.preg = preg;
    this.tag = tag;
    this.decimalPlace = decimalPlace;
    this.locked = locked;
  }

  static fromRaw(raw: any): Blockchain {
    return new Blockchain(
      raw.idBlockchain,
      String(raw.name),
      String(raw.preg),
      Boolean(raw.tag),
      Number(raw.decimalPlace),
      Boolean(raw.locked),
    );
  }

  clone(): Blockchain {
    return new Blockchain(
      this.idBlockchain,
      this.name,
      this.preg,
      this.tag,
      this.decimalPlace,
      this.locked,
    );
  }

  toPayload(): any {
    const payload: any = {
      name: this.name,
      preg: this.preg,
      tag: this.tag,
      decimalPlace: this.decimalPlace,
    };
    if (this.idBlockchain !== 0) {
      payload.idBlockchain = this.idBlockchain;
    }
    return payload;
  }
}
